<template>
  <div class="min-h-hero lg:flex lg:flex-col pb-8 lg:pb-7 bg-paint">
    <div class="flex-1 flex items-center justify-center px-ogs-large">
      <div class="flex flex-col items-center py-28 lg:py-10">
        <div class="max-w-sm text-center space-y-2">
          <h1 class="text-xl text-theme leading-snug">
            {{ product.title }}
          </h1>
          <p class="text-theme text-sm md:text-base">
            {{ product.description }}
          </p>
        </div>
      </div>
    </div>

    <div class="px-ogs-large lg:py-7">
      <ProductVariantSelector
        class="col-span-12 lg:col-span-8 lg:flex lg:items-end lg:justify-end lg:space-x-10"
        :sizes="sizes"
        :sheens="[]"
        :selected-size="selectedSize"
        :selected-sheen="false"
        :open-above="true"
        @change-size="selectedSize = $event"
      />
    </div>
    <div
      class="grid grid-cols-12 gap-x-gs gap-y-4 px-ogs-large pt-8 lg:pt-7 lg:border-t lg:border-theme"
    >
      <div
        class="col-start-5 col-span-4 hidden lg:flex items-center justify-center"
      >
        <h4
          class="text-theme opacity-70 leading-tight text-center"
          data-testid="selected-variant-details"
        >
          {{ product.title }} / {{ selectedSize.title }}
        </h4>
      </div>
      <ProductAddToCartForm
        :variant="variant"
        :loading="isLoading"
        class="col-span-12 lg:col-start-11 lg:col-span-2 flex items-center justify-end space-x-3"
      />
    </div>
  </div>
</template>

<script>
import api from "../../js/apiClient";
import ProductAddToCartForm from "./ProductAddToCartForm.vue";
import ProductVariantSelector from "./ProductVariantSelector.vue";

export default {
  name: "ProductSupplementary",

  components: { ProductAddToCartForm, ProductVariantSelector },

  props: {
    product: {
      type: Object,
      required: true,
    },
    sizes: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      selectedSize: this.sizes[0],
      variant: null,
    };
  },

  watch: {
    selectedSize() {
      this.getData();
    },
  },

  created() {
    this.getData();
  },

  methods: {
    async getData() {
      this.isLoading = true;
      try {
        const { variant } = await api.variants.querySupplementaries(
          this.product.id,
          this.selectedSize.id
        );
        this.variant = variant;
        this.isLoading = false;
      } catch (err) {
        // eslint-disable-next-line
        console.error(err);
        this.variant = null;
        this.isLoading = false;
      }
    },
  },
};
</script>
